// Importar classes primeiro
import { EmpresasRepository } from './empresas.repository';
import { ExamesRepository } from './exames.repository';
import { ClinicasRepository } from './clinicas.repository';
import { PedidosRepository } from './pedidos.repository';
import { DocumentosRepository } from './documentos.repository';

// Exportar classes
export { BaseRepository } from './base.repository';
export { EmpresasRepository } from './empresas.repository';
export { ExamesRepository } from './exames.repository';
export { ClinicasRepository } from './clinicas.repository';
export { PedidosRepository, type CreatePedidoDto, type PedidoResponse, type AgendamentoItem } from './pedidos.repository';
export { plansRepository, type IPlansRepository } from './plans.repository';
export { DocumentosRepository } from './documentos.repository';

// Singleton instances para uso nos serviços
let empresasRepositoryInstance: EmpresasRepository | null = null;
let examesRepositoryInstance: ExamesRepository | null = null;
let clinicasRepositoryInstance: ClinicasRepository | null = null;
let pedidosRepositoryInstance: PedidosRepository | null = null;
let documentosRepositoryInstance: DocumentosRepository | null = null;

export const getEmpresasRepository = (): EmpresasRepository => {
  if (!empresasRepositoryInstance) {
    empresasRepositoryInstance = new EmpresasRepository();
  }
  return empresasRepositoryInstance;
};

export const getExamesRepository = (): ExamesRepository => {
  if (!examesRepositoryInstance) {
    examesRepositoryInstance = new ExamesRepository();
  }
  return examesRepositoryInstance;
};

export const getClinicasRepository = (): ClinicasRepository => {
  if (!clinicasRepositoryInstance) {
    clinicasRepositoryInstance = new ClinicasRepository();
  }
  return clinicasRepositoryInstance;
};

export const getPedidosRepository = (): PedidosRepository => {
  if (!pedidosRepositoryInstance) {
    pedidosRepositoryInstance = new PedidosRepository();
  }
  return pedidosRepositoryInstance;
};

export const getDocumentosRepository = (): DocumentosRepository => {
  if (!documentosRepositoryInstance) {
    documentosRepositoryInstance = new DocumentosRepository();
  }
  return documentosRepositoryInstance;
};

